import { Link } from "react-router-dom";
import TrustExternalLinks from "../TrustExternalLinks";

/**
 * Internal-linking strip that surfaces all department pivots and Paris specialty pages.
 * Goal: dense, contextually-relevant maillage that boosts PageRank flow between high-priority hubs.
 *
 * Use `exclude` to remove the current page from the list.
 * Example: <InterPivotLinks exclude="paris" />
 *
 * Also embeds the 3 trust external links (Service-Public / QualiRépar / ADEME)
 * so every page using this component exposes authoritative outbound links in
 * its main content area (not only in the footer).
 */

const PIVOTS = [
    { key: "paris", to: "/reparateur-electromenager-paris", label: "Paris (20 arr.)", desc: "Hub principal capitale", icon: "fa-city" },
    { key: "urgent", to: "/reparateur-electromenager-paris-urgent", label: "Paris urgence", desc: "Intervention le jour même", icon: "fa-triangle-exclamation" },
    { key: "codes", to: "/codes-erreur", label: "Codes erreur", desc: "Encyclopédie F01, E15, dE…", icon: "fa-circle-info" },
    { key: "compare", to: "/comparatif-arrondissements-paris-electromenager-2026", label: "Comparatif 20 arrondissements", desc: "Eau, prix, délai, encastré", icon: "fa-chart-simple" },
    { key: "92", to: "/reparateur-electromenager-hauts-de-seine", label: "Hauts-de-Seine (92)", desc: "26 communes", icon: "fa-location-dot" },
    { key: "78", to: "/reparateur-electromenager-yvelines", label: "Yvelines (78)", desc: "Versailles, St-Germain…", icon: "fa-location-dot" },
    { key: "94", to: "/reparateur-electromenager-val-de-marne", label: "Val-de-Marne (94)", desc: "Vincennes, St-Maur…", icon: "fa-location-dot" },
];

export default function InterPivotLinks({ exclude, title = "Explorer aussi", bgClassName = "bg-[var(--paper)] border-y border-[var(--line)]" }) {
    const items = PIVOTS.filter((p) => p.key !== exclude);
    return (
        <section className={bgClassName}>
            <div className="max-w-7xl mx-auto px-5 lg:px-10 py-12">
                <TrustExternalLinks className="mb-10 border-t-0 pt-0" />
                <div className="divider-amber mb-5" />
                <h2 className="heading text-2xl lg:text-3xl font-extrabold">{title}</h2>
                <div className="grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3 mt-6">
                    {items.map((p) => (
                        <Link
                            key={p.key}
                            to={p.to}
                            className="card-soft p-4 block group"
                            data-testid={`pivot-link-${p.key}`}
                        >
                            <i className={`fa-solid ${p.icon} text-[var(--amber)] text-base`} />
                            <h3 className="heading font-extrabold text-sm text-[var(--navy)] group-hover:text-[var(--amber)] mt-2">
                                {p.label}
                            </h3>
                            <p className="text-xs text-[var(--ink-soft)] mt-1">{p.desc}</p>
                        </Link>
                    ))}
                </div>
            </div>
        </section>
    );
}
